import * as actionTypes from './actionTypes'
import {sortFilteredList} from './ratingUtils'

const initialState = {
  ratingsList: [],
  filteredServicesCollection:[],
  servicesCollectionList:[],
  sourceCityList:[],
  destCityList:[],
  busTypeList:[],
  paytmOperatorId:'',
  operatorDashboardRatings:{},
  sorting: {
    sortBy: '',
    sortType: 'dsc',
  },
  detailsView :false,
  detailsPayload:{},
  totalServiceCount: null,
  sourceCitiesV2: [],
  destCitiesV2: [],
  filteredDestCityList: [],
  filteredBusTypeList: [],
  unReviewedList: [],
  showAskForReviews: false,
  totalUnReviewedList: 0,
  notificationStatus: false
};

export default (state = initialState, { type, payload, query }) => {
  switch (type) {
    case actionTypes.RATINGS_LIST:
      let servicesCollectionList=[], sourceCityList=[], destCityList=[], busTypeList=[],filteredServicesCollection=[];
      const ratingsList = payload.body &&  payload.body.content && payload.body.content.routes;
      const totalServiceCount = payload.body &&  payload.body.content && payload.body.content.service_count;
      let paytmOperatorId='';
      let sorting = {
        sortBy: '',
        sortType: 'dsc',
      }
      if (ratingsList.length){
        ratingsList.forEach((route)=>{
          if (sourceCityList.indexOf(route.paytm_source_name)===-1){
            sourceCityList.push(route.paytm_source_name)
          }
          if (destCityList.indexOf(route.paytm_dest_name) === -1) {
            destCityList.push(route.paytm_dest_name)
          }
          
          route.services && route.services.forEach((service,index)=>{
            service.paytm_dest_name = route.paytm_dest_name;
            service.paytm_source_name = route.paytm_source_name;
            if (busTypeList.indexOf(service.bus_type) === -1) {
              busTypeList.push(service.bus_type)
            }
            service.busTags = service.rnr && service.rnr.rating_details && service.rnr.rating_details.question_details && service.rnr.rating_details.question_details.map((question)=> question.name);
            service.busTags = service.busTags || [];
            service.hasRatings = service.rnr && service.rnr.rating_details && (Object.keys(service.rnr.rating_details).length > 0)? true :false;
            servicesCollectionList.push(service);
          })
        });
        paytmOperatorId=ratingsList[0].services[0].rnr.paytm_trip_id.split(":")[2];
        filteredServicesCollection = JSON.parse(JSON.stringify(servicesCollectionList));
      }
      return { ...state,
              ratingsList,
              paytmOperatorId,
              servicesCollectionList ,
              sourceCityList,
              destCityList,
              busTypeList,
              filteredServicesCollection,
              sorting,
              totalServiceCount,
            };
    case actionTypes.SORT_DATA_BY:
      let sortedCollection=sortFilteredList(query, state.filteredServicesCollection);
      return {
        ...state,
        sorting:query,
        filteredServicesCollection:sortedCollection
      };
    case actionTypes.CHANGE_VIEW:
      return {
        ...state,
        detailsView: query.detailsView
      };
    case actionTypes.FILTER_RATINGS_LIST:
      const { source, destination, busType } = query;
      let sortingSearch = {
        sortBy: '',
        sortType: 'dsc',
      }
      let fitleredArray = state.servicesCollectionList.filter((service) =>
        ((source ? service.paytm_source_name === source : true) && (destination ? service.paytm_dest_name === destination : true) && (busType ? service.bus_type === busType : true)));
      return {
        ...state,
        filteredServicesCollection: fitleredArray,
        sorting: sortingSearch,
      }; 
    case actionTypes.OPERATOR_DASHBOARD_RATINGS:
      const operatorDashboardRatings = payload.content.ratings_data;
      return {
        ...state,
        operatorDashboardRatings
      };
    case actionTypes.ROUTE_RATINGS_DETAILS:
      const detailsView = !!payload.content;
      const detailsPayload=payload;
      return {
        ...state,
        detailsPayload,
        detailsView
      };
    case actionTypes.V2_SOURCE_CITIES:
      const sourceCitiesV2 = payload;
      return {
        ...state,
        sourceCitiesV2
      };

    case actionTypes.V2_DEST_CITIES:
      const destCitiesV2 = payload;
      return {
        ...state,
        destCitiesV2
      };

    case actionTypes.SHOW_ASK_FOR_REVIEWS:
      return {
        ...state,
        showAskForReviews: payload
      };

    case actionTypes.UNREVIEWED_LIST:      
      const unReviewedList = payload.orders;
      const showAskForReviews = payload.orders.length >= 0;
      const totalUnReviewedList = payload.totalCount;
      
      return {
        ...state,
        unReviewedList,
        showAskForReviews,
        totalUnReviewedList
      };
      
    default:
      return state
  }
}
